<template>
  <v-card
    min-width="344"
    max-width="344"
    :outlined="$vuetify.breakpoint.mdAndUp"
    class="pb-2"
    height="max-content"
  >
    <!-- header -->
    <v-list-item>
      <router-link
        :to="{
          name: 'profile',
          params: { username: post.creator.user.username }
        }"
      >
        <v-list-item-avatar>
          <v-img
            v-if="
              post.creator.profilePicture != '' &&
                post.creator.profilePicture != null
            "
            :src="post.creator.profilePicture"
            :alt="`${post.creator.user.username} avatar`"
            cover
          />
          <v-img
            v-else
            :alt="`${post.creator.user.username} avatar`"
            :src="require('@/assets/defaultProfilePicture.svg')"
            cover
          />
        </v-list-item-avatar>
      </router-link>
      <v-list-item-content style="padding: 9px 0px">
        <v-list-item-title class="underline--on--hover text-h6">
          <router-link
            :to="{
              name: 'profile',
              params: { username: post.creator.user.username }
            }"
          >
            {{ post.creator.user.username }}
          </router-link>
        </v-list-item-title>

        <v-list-item-subtitle class="text-caption">
          <span
            v-if="post.season.length"
            v-text="`${$t('share.post.seasons.' + post.season)}`"
          >
          </span>
          <span v-else>
            &nbsp;
          </span>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn
          icon
          color="primary"
          :href="post.url"
          target="_blank"
          height="40px"
          width="40px"
          @click="trackLink()"
        >
          <v-icon>
            {{ typeIcon }}
          </v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <!-- cardContent -->
    <youtube-media
      v-if="post.type === 'youtube'"
      :video-id="this.post.url.slice(this.post.url.indexOf('=') + 1)"
      player-width="100%"
      player-height="194"
      :player-vars="{
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
        origin: origin,
        controls: 0,
        fs: 0,
        playsinline: 1
      }"
      host="https://www.youtube-nocookie.com"
      style="min-height:194px; min-width:100%"
    >
    </youtube-media>
    <v-hover v-else v-slot:default="{ hover }" open-delay="200">
      <a :href="post.url" target="_blank" @click="trackLink()">
        <v-tooltip top dark>
          <template v-slot:activator="{ on }">
            <v-img
              :src="
                post.picture === ''
                  ? require('@/assets/defaultCardPicture.png')
                  : post.picture
              "
              :gradient="
                hover ? '' : 'to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)'
              "
              height="194"
              width="100%"
              class="white--text align-end post-image"
              v-on="on"
            >
              <v-card-title
                v-show="!hover"
                v-text="post.displayTitle"
                class="text-left word-break-break-word font-weight-bold"
              ></v-card-title>
            </v-img>
          </template>
          <span v-text="post.title" class="font-weight-bold"></span>
        </v-tooltip>
      </a>
    </v-hover>
    <!-- locations loop for locations.length -->
    <router-link
      :to="{
        name: 'home',
        query: {
          placeType: destination.location.properties.placeType,
          shortName: destination.location.properties.shortName,
          longName: destination.location.properties.longName,
          xMin: destination.location.properties.city.bbox[0],
          xMax: destination.location.properties.city.bbox[2],
          yMin: destination.location.properties.city.bbox[1],
          yMax: destination.location.properties.city.bbox[3],
          longitude: destination.location.geometry.coordinates[0],
          latitude: destination.location.geometry.coordinates[1]
        }
      }"
      v-for="destination in post.destinations"
      :key="destination.id"
    >
      <v-list-item>
        <v-list-item-icon class="mr-4">
          <v-icon color="primary">{{ "$" + destination.category }}</v-icon>
        </v-list-item-icon>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-list-item-content v-on="on">
              <v-list-item-title
                v-text="destination.location.properties.longName"
                class="underline--on--hover primary--text"
              >
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <span v-html="destination.location.properties.longName"></span>
        </v-tooltip>
      </v-list-item>
    </router-link>
    <!-- Tags -->
    <div v-if="post.themes.length" class="px-4">
      <div class="d-flex align-center flex-wrap py-2">
        <v-chip
          v-for="theme in post.themes"
          :key="theme.name"
          :to="{
            name: 'home',
            query: {
              themes: [theme.name],
              page: 1
            }
          }"
          v-text="theme.name"
          :draggable="false"
          color="#dea70f16"
          class="mr-1 my-1 text-subtitle-2 text-capitalize secondary-text"
          style="color: #dea70f !important"
        ></v-chip>
      </div>
    </div>
    <v-card-actions v-if="postIsEditable" class="justify-end px-4 pt-0">
      <v-btn
        @click.stop="editPost()"
        depressed
        v-text="$t('share.edit')"
        color="secondary"
      ></v-btn>
    </v-card-actions>
    <!-- Link -->
    <a :href="post.url" target="blank" @click="trackLink()">
      <div class="px-4 d-flex align-center justify-center">
        <span
          class="text-caption text-truncate d-inline-block grey--text"
          v-text="post.url"
          style="max-width:100%"
        >
        </span>
        <v-icon small color="grey" class="ml-2">open_in_new</v-icon>
      </div>
    </a>
  </v-card>
</template>

<script>
import MatomoMixins from "@/services/MatomoMixins";
export default {
  name: "BasePostCard",
  mixins: [MatomoMixins],
  props: {
    post: {
      type: Object,
      required: true
    },
    postIsEditable: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      player: null
    };
  },
  computed: {
    isManagePost() {
      return this.$store.getters.isManagePost;
    },
    typeIcon() {
      switch (this.post.type) {
        case "externalLink":
          return "fas fa-link";
        case "youtube":
          return "fab fa-youtube";
        case "poi":
          return "fas fa-info-circle";
      }
      return "";
    },
    origin() {
      return window.location.origin;
    }
  },
  methods: {
    editPost() {
      this.$store.dispatch("managePost", this.post);
    },
    hoverLocation(locationApiId) {
      this.$emit("hoverLocation", locationApiId);
    },
    leaveLocation(locationApiId) {
      this.$emit("leaveLocation", locationApiId);
    },
    trackLink() {
      this.MATOMO_trackExternalLink(this.post, "externalLinkOnCard");
    }
  }
};
</script>
<style></style>
